import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { getAnchorElementFromEvent } from '@noths/polaris-client-utils';

import * as styles from './AdvancedCopyBlock.style';

export interface AdvancedCopyBlockProps {
  children: React.ReactNode;
  onLinkClick?: (e: React.MouseEvent) => void;
  onVisible?: () => void;
}

export const AdvancedCopyBlock = ({
  children,
  onLinkClick,
  onVisible = () => {},
}: AdvancedCopyBlockProps) => {
  const observedElementRef = useImpressionRef<HTMLDivElement>(() => onVisible());

  const handleClick = (e: React.MouseEvent) => {
    if (getAnchorElementFromEvent(e)) {
      onLinkClick?.(e);
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div css={styles.copyContainer} onClick={handleClick} ref={observedElementRef}>
      {children}
    </div>
  );
};
